enum S3UploadTypeEnum {
    ITEM_TEMPLATE = "item_template",
    CHILD_ITEM_TEMPLATE = "child_item_template",
    PRICE_LIST = "price_list",
    VENDOR_CSV = "vendor_csv",
    BULK_ORDERS_CSV = "bulk_orders_csv",
    ITEM_CATEGORIES = "item_categories",
    SHIPMENTS_CSV = "shipments_csv",
    PRICE_BANDS_CSV = "price_bands_csv",
    BULK_ITEM_OPTIONS = "bulk_item_options",
    CATALOG_ATTRIBUTES_CSV = "catalog_attributes_csv",
    BULK_KIT_BUILDER = "bulk_kit_builder",
    PRICE_BANDS_BULK_APPLY = "price_bands_bulk_apply",
    ITEM_OPTIONS_ASSIGN = "item_options_assign",
    // Delivery app types
    DELIVERY_PHOTO = "delivery_photo",
    DELIVERY_SIGNATURE = "delivery_signature",
}

export default S3UploadTypeEnum;
